import { DEFAULT_STATUS_FILTER } from "@performyard/service-contracts";

export type StatusFilter = "any" | "active" | "archived";

export const DEFAULT_STATUS: StatusFilter = DEFAULT_STATUS_FILTER;

export const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
	{ value: "any", label: "Any" },
	{ value: "active", label: "Active" },
	{ value: "archived", label: "Archived" },
];

// Assignment-status variant: an archived ASSIGNMENT reads as "Unassigned" (matching the table
// chips) — "Archived" stays correct for the Roles / Competencies admin tabs, where the entity
// itself archives. The wire value is unchanged; only the label differs.
export const ASSIGNMENT_STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
	{ value: "any", label: "Any" },
	{ value: "active", label: "Active" },
	{ value: "archived", label: "Unassigned" },
];

// CompetencyAssignmentsCsv/internal/csv.ts keeps its own deliberately-different filename labels.
export const ASSIGNMENT_STATUS_LABELS: Record<StatusFilter, string> = Object.fromEntries(
	ASSIGNMENT_STATUS_OPTIONS.map((option) => [option.value, option.label])
) as Record<StatusFilter, string>;

export const STATUS_LABELS: Record<StatusFilter, string> = Object.fromEntries(
	STATUS_OPTIONS.map((option) => [option.value, option.label])
) as Record<StatusFilter, string>;

// Shared default fallback used by every status filter panel (Competencies + Roles admin tabs).
export const resolveStatus = <T extends { status?: StatusFilter }>(filters: T): StatusFilter =>
	filters.status ?? DEFAULT_STATUS;

// Status chip is non-dismissible while at the default so it can't be dismissed into an
// unrepresentable "no status" state.
export const getNonDismissibleChipIds = <T extends { status?: StatusFilter }>(filters: T): string[] =>
	resolveStatus(filters) === DEFAULT_STATUS ? ["status"] : [];
